import { render, staticRenderFns } from "./ArticleBodyExtract.vue?vue&type=template&id=3f858eb5&scoped=true&"
import script from "./ArticleBodyExtract.vue?vue&type=script&lang=js&"
export * from "./ArticleBodyExtract.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBodyExtract.vue?vue&type=style&index=0&id=3f858eb5&scoped=true&lang=css&"
import style1 from "./ArticleBodyExtract.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f858eb5",
  null
  
)

export default component.exports